import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ApiResponse} from '../models/api-response.model';
import {ReferenceCode} from '../models/item-variation.model';

@Injectable({providedIn: 'root'})
export class ReferenceCodeService {
  constructor(private httpClient: HttpClient) {}

  list(orgId: string): Observable<ApiResponse<ReferenceCode[]>> {
    const url = environment.apiUrl + `v3/commerce/clare/tenants/${orgId}/reference_codes`;
    return this.httpClient.get<any>(url, { withCredentials: true, headers: { Accept: 'application/json' } });
  }
}
